module.exports = __webpack_public_path__ + "img/service4.bd7f9328.png";